<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BsXKmC/tc-custom/9781609255640.jpg?1700880628512" alt="This image is the cover for the book Ecstasy of Enlightenment"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ecstasy of Enlightenment
      </h1>
      <p class="bookDescription body article font2">
        <p>The Ecstasy of Enlightenment is an inside look at the spiritual world of Tantra--one of the most sophisticated, alluring, and controversial forms of Buddhism. Cleary unlocks the mysteries of the Carya-Giti, a collections of teachings by more than twenty famous Siddhas, or Tantric adepts, who lived during the illustrius Pala dynasty of old Bengal. These teachings emanate from one of the most dynamic sources of international Buddhism, at the height of its religious development, and as such, they are completely nonsectarian. Particularly noteworth is Cleary's demonstration of the parallels between Tantric Buddhism in Old Bengal and the original Zen Buddhism of China.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Cleary
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Samuel Weiser, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?445fd65e